import { NgModule } from '@angular/core'

import { CommonModule } from '@angular/common'

import { ViewerControlsPanelComponent } from './viewer-controls-panel/viewer-controls-panel.component'

import { ViewerLayersComponent } from './viewer-controls-panel/viewer-layers/viewer-layers.component'

import { SingleLayerDetailComponent } from './viewer-controls-panel/single-layer-detail/single-layer-detail.component'

import { UiLibraryModule } from '../ui-library/ui-library.module'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { LayerGroupComponent } from './viewer-controls-panel/viewer-layers/layer-group/layer-group.component'

import { LetDirective } from '@ngrx/component'

import { NeuroglancerFrameComponent } from './neuroglancer-frame/neuroglancer-frame.component'

import { CaseViewerComponent } from './case-viewer.component'

import { SharedModule } from '../shared/shared.module'

import { SelectionModule } from '../selection/selection.module'

import { LayerGroupDetailComponent } from './viewer-controls-panel/layer-group-detail/layer-group-detail.component'

import { ResultsModule } from '../results/results.module'

import { LayerGroupsComponent } from './viewer-controls-panel/viewer-layers/layer-groups/layer-groups.component'

import { LayerGroupItemComponent } from './viewer-controls-panel/viewer-layers/layer-groups/layer-group-item/layer-group-item.component'

import { LayerGroupTitleComponent } from './viewer-controls-panel/viewer-layers/layer-groups/layer-group-title/layer-group-title.component'

import { FavoriteLayersDialogComponent } from './viewer-controls-panel/viewer-layers/layer-groups/favorite-layers-dialog/favorite-layers-dialog.component'

import { RenameLayerDialogComponent } from './viewer-controls-panel/single-layer-detail/rename-layer-dialog/rename-layer-dialog.component'



@NgModule({

    declarations: [

        ViewerControlsPanelComponent,

        ViewerLayersComponent,

        SingleLayerDetailComponent,

        LayerGroupDetailComponent,

        LayerGroupComponent,

        NeuroglancerFrameComponent,

        CaseViewerComponent,

        LayerGroupsComponent,

        LayerGroupItemComponent,

        LayerGroupTitleComponent,

        FavoriteLayersDialogComponent,

        RenameLayerDialogComponent,

    ],

    imports: [

        CommonModule,

        FormsModule,

        ReactiveFormsModule,

        UiLibraryModule,

        LetDirective,

        SharedModule,

        SelectionModule,

        ResultsModule,

    ],

})

export class CaseViewerModule {}

